const isValidDate = (dateValue: string | null | undefined): boolean => {
  if (!dateValue) return false
  const date = new Date(dateValue)
  return !isNaN(date.getTime())
}

const formatTime = (date) => {
  let hours = date.getHours()
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const period = hours >= 12 ? 'PM' : 'AM'

  hours = hours % 12
  hours = hours ? hours : 12

  return `${hours}:${minutes} ${period}`
}

export const formatStarTimeWebinar = (startTime) => {
  if (!isValidDate(startTime)) return ''

  const start = new Date(startTime!)

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const startLocal = new Date(
    start.toLocaleString('en-US', { timeZone: userTimeZone })
  )

  return `${formatTime(startLocal)}`
}

export const webinarStartTime = (startTime) => {
  if (!isValidDate(startTime)) return ''

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const start = new Date(startTime!)

  const startLocal = new Date(
    start.toLocaleString('en-US', { timeZone: userTimeZone })
  )

  return `${formatTime(startLocal)}`
}

export const webinarEndTime = (startTime, duration) => {
  if (!isValidDate(startTime)) return ''

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const start = new Date(startTime!)
  const end = new Date(start.getTime() + duration * 60000)

  const endLocal = new Date(
    end.toLocaleString('en-US', { timeZone: userTimeZone })
  )

  return `${formatTime(endLocal)}`
}
